import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../components/login";
import Signup from "../components/signup";
import Layout from "../components/layout/Layout";
import Dashboard from "../components/dashboard/Dashboard";
import CampURLs from "../components/CampURLs/CampURLs";
import CampaignsMaster from "../components/CampaignsMaster/CampaignsMaster";
import CodeTypeEditor from "../components/CodeTypeEditor/CodeTypeEditor";
import CountriesExcept from "../components/CountriesExcept/CountriesExcept";
import CronResolverConfig from "../components/CronResolverConfig/CronResolverConfig";
import NewClicks from "../components/NewClicks/NewClicks";
import ExcludedUrls from "../components/ExcludedUrls/ExcludedUrls";
import CollectionStats from "../components/CollectionStats/CollectionStats";
import { PrivateRoutes, LoginRoutes } from "../context/authContext";
// import DateWiseReport from "../components/ClicksReport/DateWiseReport";
// import UploadCSV from "../components/ConversionReport/UploadCSV";
// import Conversioncampaignwise from "../components/ConversionReport/Conversioncampaignwise/Conversioncampaignwise";
// import Conversiondatewise from "../components/ConversionReport/Conversiondatewise/Conversiondatewise";

// import AllConversionReports from "../components/ConversionReport/AllConversionReports/AllConversionReports";
import CampWiseReport from "../components/Reports/CampWiseReport";
import PageNotFound from "../components/PageNotFound";
import CampaignUploadCsv from "../components/CampaingnUploadCsv";
import PerformanceWiseReport from "../components/Reports/PerformanceWiseReport";
import Profile from "../components/profile/Profile";

//=========================================Profile Operation module=========================================//
import ViewAdditionalRoles from "../components/operations/ViewAdditionalRoles";
import UserRoles from "../components/operations/UserRoles";
import ViewModules from "../components/operations/ViewModules";
import RoleModules from "../components/operations/RoleModules";
import AllUser from "../components/operations/AllUser";
import Approve from "../components/operations/Approve";
import CreateUser from "../components/operations/CreateUser";
import RoleCheck from "../components/RoleCheck/RoleCheck";
import PerformanceReport from "../components/Reports/CampWiseReport";
import ClickReport from "../components/Reports/PerformanceWiseReport";
import Unauthorized from "../components/Unauthorized";
import LinkFetcher from "../components/Reports/LinkFetcher";

function MainRoutes() {
  return (
    <>
      <Routes>
        <Route element={<LoginRoutes />}>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
        </Route>
        <Route
          element={
            <Layout>
              <PrivateRoutes />
            </Layout>
          }
        >
          <Route path="/" element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />

          {/* Operations */}
          {/* <Route
            path="/operation/additional-roles"
            element={<ViewAdditionalRoles />}
          /> */}
          {/* <Route path="/operation/user-roles" element={<UserRoles />} /> */}
          {/* <Route path="/operation/modules" element={<ViewModules />} /> */}
          <Route element={<RoleCheck />}>
            <Route path="/admin/role-modules" element={<RoleModules />} />
            <Route path="/admin/all-users" element={<AllUser />} />
          </Route>
          {/* <Route path="/admin/approve" element={<Approve />} /> */}
          {/* <Route path="/admin/create-user" element={<CreateUser />} /> */}

          <Route path="/camplinks" element={<CampURLs />} />
          <Route path="/campaigns" element={<CampaignsMaster />} />
          <Route path="/codetype" element={<CodeTypeEditor />} />
          <Route path="/countries-except" element={<CountriesExcept />} />
          <Route path="/cron-resolver" element={<CronResolverConfig />} />
          <Route path="/campaigns/upload_csv" element={<CampaignUploadCsv />} />
          {/* <Route path="/campaigns/view_graph" element={<CampaignViewGraph />} /> */}

          {/* ------------------route for reports------------------ */}
          <Route path="/reports/performance" element={<PerformanceReport />} />
          <Route path="/reports/click" element={<ClickReport />} />

          {/* <Route path="/upload-csv" element={<UploadCSV />} /> */}
          {/* <Route path="/action/date-wise" element={<Conversiondatewise />} /> */}
          {/* <Route
            path="/action/brand-wise"
            element={<Conversioncampaignwise />}
            /> */}
          {/* <Route
            path="/action/conversion-reports"
            element={<AllConversionReports />}
            /> */}
          <Route path="/linkfetcher" element={<LinkFetcher />} />
          <Route path="/new-clicks" element={<NewClicks />} />
          <Route path="/excluded-urls" element={<ExcludedUrls />} />
          <Route path="/collection-stats" element={<CollectionStats />} />
        </Route>
        <Route path="*" element={<PageNotFound />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
      </Routes>
    </>
  );
}
export default MainRoutes;
